<template>
	<div class="page">
		<!-- 搜索 -->
		<div class="search-box">
			<input v-model="keyword" type="search" class="search-input" placeholder="请输入疾病名称的1-2个字" />
			<div class="search-btn" @click="goSearch">搜索</div>
		</div>
		<!-- 内容 -->
		<div class="content">
			<model-part :direction="direction" @change="changeBody" @clickPart="showDisease"></model-part>
		</div>
		<!-- 抽屉 -->
		<popup class="popup" v-model="show" position="right">
			<organ-list :partId="partId" :partName="partName" @click="clickDisease"></organ-list>
		</popup>
		<!-- 结果 -->
		<popup v-model="result" style="top: 45px" :overlay-style="{'top': '45px'}" position="top">
			<div class="result-list">
				<div class="result-item" v-for="(item, index) in diseaseList" :key="index" @click.stop="clickDisease(item.id)">
					<div>{{item.diseaseName}}</div>
					<icon name="arrow"></icon>
				</div>
			</div>
		</popup>
	</div>
</template>

<script>
	import Vue from 'vue'
	import ModelPart from '@/components/ModelPart'
	import OrganList from '@/components/OrganList'
	import {
		Popup,
		Toast,
		Icon
	} from 'vant'
	import 'vant/lib/popup/style'
	import 'vant/lib/toast/style'
	import wx from 'weixin-js-sdk'
	import {
		searchDisease
	} from '@/api/nutrition'

	Vue.use(Toast)

	export default {
		name: 'Healthy',
		components: {
			ModelPart,
			OrganList,
			Popup,
			Icon
		},
		data() {
			return {
				keyword: null,
				direction: 0,
				partId: null,
				partName: null,
				show: false,
				result: false,
				diseaseList: []
			}
		},
		created() {
			document.title = '自助康养'
		},
		methods: {
			goSearch() {
				if (this.keyword) {
					// 请求搜索
					searchDisease({
						diseaseName: this.keyword
					}).then(res => {
						this.diseaseList = res.result
						this.result = true
					})
				} else {
					Toast('请输入关键词')
				}
			},
			changeBody(value) {
				this.direction = value
			},
			showDisease(partId, partName) {
				// 点击部位显示病症
				this.partId = partId
				this.partName = partName
				this.show = !this.show
			},
			clickDisease(id) {
				// 点击的疾病ID
				let path = encodeURIComponent(location.origin + '/detail?id=' + id);
				if (window.__wxjs_environment === 'miniprogram') {
					wx.miniProgram.navigateTo({
						url: '/pages/other/webView/main?path=' + path
					});
				} else {
					uni.navigateTo({
						url: '/pages/other/webView/main?path=' + path
					});
					location.href = 'medical://nutrition?id=' + id;
				}
			}
		}
	}
</script>

<style scoped>
	.page {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100vh;
		overflow: hidden;
		background-color: white;
	}

	.search-box {
		display: flex;
		flex-direction: row;
		align-items: center;
		border-radius: 5px;
		overflow: hidden;
		margin: 10px;
		flex-shrink: 0;
	}

	.search-box .search-input {
		flex: 1;
		text-align: center;
		line-height: 30px;
		padding: 0 10px;
		color: black;
		background-color: whitesmoke;
		border: none;
		border-radius: 5px;
	}

	.search-box .search-btn {
		margin-left: 10px;
		color: #0063aa;
	}

	.content {
		flex: 1;
		width: 100%;
		overflow: hidden;
		background: white;
	}

	.list {
		border-top: 1px solid #f2f2f2;
		padding: 0 10px;
	}

	.list .row {
		padding: 5px 0;
		border-bottom: 1px solid #f2f2f2;
	}

	.popup {
		width: 70%;
		height: 100%;
	}

	.result-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 10px 15px;
		color: #666666;
		background-color: white;
		border-bottom: 1px solid #f2f2f2;
	}

	.result-item div {
		flex: 1;
	}

	.result-item img {
		width: 6px;
		height: 10px;
	}
</style>